import pentestStyle from "./pentestComponent.module.css";

import { SquareArrowOutUpRight, Trash2 } from "lucide-react";

import { CategoryType, Pentest, TypeType } from "../../../../sdkStructs.ts";

interface Props {
  data: Pentest;
  deleteFunc: (id: number) => void;
  openFunc: (id: number) => void;

  owned: boolean, // Use to display exit instead of trash if pentest not owned by user
}

function getCategory(type: CategoryType) {
  if (type === "blackbox") return "Blackbox";
  if (type === "whitebox") return "Whitebox";
  return "Graybox";
}
function getType(type: TypeType) {
  if (type === "internal") return "Internal";
  return "External";
}

function PentestComponent({ data, deleteFunc, openFunc }: Readonly<Props>) {
  function deleteThis(event: React.MouseEvent<HTMLDivElement>) {
    deleteFunc(data.ID);
    event.stopPropagation();
  }
  function openThis() {
    openFunc(data.ID);
  }

  return (
    <div className={pentestStyle.pentestWrapper}>
      <div className={pentestStyle.topRow}>
        <h4 className={pentestStyle.pentestTitle}>{data.Title}</h4>

        <div className={pentestStyle.trashButton} onClick={deleteThis}>
          <Trash2 color="var(--light-blue-icon)" strokeWidth="1.5" />
        </div>
      </div>

      <button className={pentestStyle.bottomRow} onClick={openThis} id="open-pentest-button">
        <span className={pentestStyle.dataText}>
          {getCategory(data.Category)} / {getType(data.Type)} @ {data.Client}
        </span>
        <span className={pentestStyle.dataText + " " + pentestStyle.openText}>Open</span>
        <SquareArrowOutUpRight className={pentestStyle.openPentestIcon} color="white" width="1.5" />
      </button>
    </div>
  );
}

export default PentestComponent;
